import script from "./OrganizationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationsTable.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationsTable.vue?vue&type=style&index=0&id=45d040fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d040fc"]])

export default __exports__